interface IFieldLabelProps {
  children: React.ReactNode;
  hint?: React.ReactNode;
}

/**
 * Standalone field label + optional hint, for fields that sit directly inside a
 * SectionCard body (rather than in a ToggleRow/FieldRow list). Shared across the
 * bot config surfaces (Book Demo, Video Avatar, AI & Persona).
 */
const FieldLabel: React.FC<IFieldLabelProps> = ({ children, hint }) => (
  <div className="mb-2">
    <span className="block text-sm font-semibold text-gray-800">{children}</span>
    {hint && <span className="mt-0.5 block text-[13px] text-gray-500">{hint}</span>}
  </div>
);

export default FieldLabel;
